/**
 * @file
 * Drupal's states library.
 */

(function ($, Drupal) {
  /**
   * Global state change handlers. These are bound to "document" to cover all
   * elements whose state changes. Events sent to elements within the page
   * bubble up to these handlers. We use this system so that themes and modules
   * can override these state change handlers for particular parts of a page.
   */
  const $document = $(document);

  /**
   * Handle multiple state change for select
   * - update the name to have prefixed [].
   * - update multiple attribute.
   * - reinitiate select2 if that is used.
   */
  $document.on('state:multiple', (e) => {
    if (e.trigger) {
      const $target = $(e.target);
      const multiple = e.value;
      if (e.target.tagName === 'SELECT') {
        if (multiple) {
          // name will be [] to include multiple choices,
          // can't remove it from single option as the form builder will not get value
          // and validation would fail.
          let name = $target.attr('name') || '';
          name = name.replace('[]', '');
          $target.attr('name', `${name}[]`);
          $target.attr('multiple', '');
        } else {
          $target.removeAttr('multiple');
        }
      }

      // reinitiate the select2 with config
      if ($target.hasClass('select2-hidden-accessible')) {
        const config = $target.data('select2-config');

        if (config.multiple !== multiple) {
          config.multiple = multiple;
          $target.data('select2-config', config);

          if (Drupal.VeoliaSelect2) {
            $target.trigger('select2:destroy');
            new Drupal.VeoliaSelect2($target.closest('.js-form-item'));
          }
        }
      }
    }
  });
}(jQuery, Drupal));
